import React from 'react'
import SeoPage from '../components/SeoPage'

import Img from '../components/Image'
import { graphql, Link } from 'gatsby'

const ContentPage = ({ data, location, ...props }) => {
    return (
        <SeoPage
            leadImage={data.img0.childImageSharp.fluid.src}
            location={location}
            title="Alcool au volant : quels véhicules sont visés par la loi?"
            description="Nous vous expliquons en quoi consiste l’infraction de conduite avec les facultés affaiblies par l’alcool, ainsi que les types de véhicules visés par cette infraction!"
            fr={undefined}
            lawType="criminal"
            specialtyText="pour Alcool au volant">
            <p>
                Les règles relatives à la consommation d’alcool et la conduite
                s'appliquent à tous les véhicules, peu importe s’ils sont sur
                les voies publiques ou non.{' '}
            </p>
            <p>
                Ainsi, outre les automobiles, les véhicules suivants sont
                également visés par de telles interdictions:
            </p>
            <ul>
                <li>Moto,</li>
                <li>VTT/motoneige,</li>
                <li>Camion</li>
                <li>Taxi, et </li>
                <li>Bateau.</li>
            </ul>
            <p>
                <Img
                    fluid={data.img0.childImageSharp.fluid}
                    title="Véhicules visés par l’alcool au volant!"
                    alt=""
                />
            </p>
            <p>
                Dans certains cas, les règles seront encore plus sévères. Ce
                sera notamment le cas lorsqu’il s’agit d’un véhicule
                professionnel (un taxi ou un autobus par exemple).{' '}
            </p>
            <p>
                <strong>
                    Voyez de quelle manière les règles s’appliquent aux
                    différents véhicules grâce à Avocats Alcool au Volant!
                </strong>
            </p>
            <table>
                <tr>
                    <td></td>
                </tr>
            </table>
            <h2>
                <strong>
                    Qu’est-ce que l’infraction de conduite avec les facultés
                    affaiblies par l’alcool?
                </strong>
            </h2>
            <p>
                La conduite avec les facultés affaiblies est une infraction qui
                peut être démontrée de deux manières distinctes.{' '}
            </p>
            <h4>
                <strong>
                    1) Conduite avec les facultés affaiblies par l’alcool, une
                    drogue ou une combinaison des deux :
                </strong>
            </h4>
            <p>
                Il s’agit du cas où une personne conduit alors que sa capacité
                de conduire est affaiblie, sans pour autant atteindre la limite
                de 80 mg par 100 ml de sang.
            </p>
            <p>
                Les policiers peuvent conclure que l
                <strong>es capacités d’un conducteur sont affaiblies</strong>{' '}
                par l’alcool, une drogue ou une combinaison des deux en se
                basant sur des preuves circonstancielles issues de leur
                observation. Ils tiennent compte de plusieurs éléments :
            </p>
            <ul>
                <li>L’odeur d’alcool dégagée par le conducteur</li>
                <li>Son allure générale (démarche, posture, apparence)</li>
                <li>Son comportement (agitation, confusion, lenteur)</li>
                <li>Son élocution et sa coordination motrice</li>
                <li>Tout autre signe révélateur d’un affaiblissement</li>
            </ul>
            <p>
                Lorsqu’aucune autre cause raisonnable n’explique ces signes, les
                policiers peuvent conclure que la capacité de conduire est
                affaiblie par une substance (alcool, drogue ou les deux).{' '}
            </p>
            <h4>
                <strong>
                    2) Présence d’un taux d’alcool égal ou supérieur à 80 mg/100
                    ml de sang :
                </strong>
            </h4>
            <p>
                En l’absence de signes d’affaiblissement, une infraction est
                commise si le taux d’alcool atteint ou dépasse 80 milligrammes
                par 100 millilitres de sang, soit un taux d’alcoolémie de
                0,08 %, dans les deux heures suivant la conduite. Si la
                consommation d’alcool a lieu uniquement après avoir arrêté de
                conduire, la personne ne peut pas être reconnue coupable.
            </p>
            <p>
                Pour mesurer ce taux, les policiers utilisent un appareil appelé
                éthylomètre ou alcootest, qui déterminent la concentration
                d’alcool dans l’haleine du conducteur. Une série de procédures
                doit obligatoirement être respectée pour confirmer que le taux
                d’alcool d’un conducteur.
            </p>
            <h3>
                <strong>
                    Quels sont les véhicules visés par l’infraction criminelle
                    de conduite avec les facultés affaiblies par l’alcool?
                </strong>
            </h3>
            <p>
                L’infraction prévue au Code criminel de conduite avec les
                facultés affaiblies ne concerne pas uniquement les
                automobilistes!
            </p>
            <p>
                <Img
                    fluid={data.img1.childImageSharp.fluid}
                    title="Interdiction d’alcool au volant pour tout moyen de transport!"
                    alt=""
                />
            </p>
            <p>
                Dans certains cas, les règles seront encore plus sévères. Ce
                sera notamment le cas lorsqu’il s’agit d’un véhicule
                professionnel (un taxi ou un autobus par exemple).{' '}
            </p>
            <p>
                <strong>
                    Voyez de quelle manière les règles s’appliquent aux
                    différents véhicules grâce à Avocats Alcool au Volant!
                </strong>
            </p>
            <table>
                <tr>
                    <td></td>
                </tr>
            </table>
            <h2>
                <strong>
                    Qu’est-ce que l’infraction de conduite avec les facultés
                    affaiblies par l’alcool?
                </strong>
            </h2>
            <p>
                La conduite avec les facultés affaiblies est une infraction qui
                peut être démontrée de deux manières distinctes.{' '}
            </p>
            <h4>
                <strong>
                    1) Conduite avec les facultés affaiblies par l’alcool, une
                    drogue ou une combinaison des deux :
                </strong>
            </h4>
            <p>
                Il s’agit du cas où une personne conduit alors que sa capacité
                de conduire est affaiblie, sans pour autant atteindre la limite
                de 80 mg par 100 ml de sang.
            </p>
            <p>
                Les policiers peuvent conclure que l
                <strong>es capacités d’un conducteur sont affaiblies</strong>{' '}
                par l’alcool, une drogue ou une combinaison des deux en se
                basant sur des preuves circonstancielles issues de leur
                observation. Ils tiennent compte de plusieurs éléments :
            </p>
            <ul>
                <li>L’odeur d’alcool dégagée par le conducteur</li>
                <li>Son allure générale (démarche, posture, apparence)</li>
                <li>Son comportement (agitation, confusion, lenteur)</li>
                <li>Son élocution et sa coordination motrice</li>
                <li>Tout autre signe révélateur d’un affaiblissement</li>
            </ul>
            <p>
                Lorsqu’aucune autre cause raisonnable n’explique ces signes, les
                policiers peuvent conclure que la capacité de conduire est
                affaiblie par une substance (alcool, drogue ou les deux).{' '}
            </p>
            <h4>
                <strong>
                    2) Présence d’un taux d’alcool égal ou supérieur à 80 mg/100
                    ml de sang :
                </strong>
            </h4>
            <p>
                En l’absence de signes d’affaiblissement, une infraction est
                commise si le taux d’alcool atteint ou dépasse 80 milligrammes
                par 100 millilitres de sang, soit un taux d’alcoolémie de
                0,08 %, dans les deux heures suivant la conduite. Si la
                consommation d’alcool a lieu uniquement après avoir arrêté de
                conduire, la personne ne peut pas être reconnue coupable.
            </p>
            <p>
                Pour mesurer ce taux, les policiers utilisent un appareil appelé
                éthylomètre ou alcootest, qui déterminent la concentration
                d’alcool dans l’haleine du conducteur. Une série de procédures
                doit obligatoirement être respectée pour confirmer que le taux
                d’alcool d’un conducteur.
            </p>
            <h3>
                <strong>
                    Quels sont les véhicules visés par l’infraction criminelle
                    de conduite avec les facultés affaiblies par l’alcool?
                </strong>
            </h3>
            <p>
                L’infraction prévue au Code criminel de conduite avec les
                facultés affaiblies ne concerne pas uniquement les
                automobilistes!
            </p>
            <p>
                <Img
                    fluid={data.img2.childImageSharp.fluid}
                    title="Conduire un kart de golf avec les facultés affaiblies est criminel!"
                    alt=""
                />
            </p>
            <p>
                Le Code criminel interdit de conduire avec les facultés
                affaiblies tout « moyen de transport », une notion définie plus
                précisément à l’article{' '}
                <Link to="https://laws-lois.justice.gc.ca/fra/lois/c-46/section-320.11.html">
                    320.11
                </Link>
                . Selon cet article, un moyen de transport couvre notamment :
            </p>
            <ul>
                <li>Les véhicules à moteur</li>
                <li>Les bateaux ou autres embarcations nautiques</li>
                <li>Les aéronefs</li>
                <li>Le matériel ferroviaire</li>
            </ul>
            <table>
                <tr>
                    <td>
                        <p>
                            <strong>Moyens de transport</strong>
                        </p>
                    </td>
                    <td colspan="2">
                        <p>
                            <strong>Exemples</strong>
                        </p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>Véhicule à moteur</p>
                    </td>
                    <td>
                        <ul>
                            <li>Voiture (automobile)</li>
                            <li>Camionnette (pick-up)</li>
                            <li>
                                Camion lourd (semi-remorque, transport routier)
                            </li>
                            <li>Motocyclette</li>
                            <li>Cyclomoteur (scooter)</li>
                            <li>Motoneige</li>
                            <li>Quad ou VTT (véhicule tout-terrain)</li>
                        </ul>
                    </td>
                    <td>
                        <ul>
                            <li>Tracteur routier ou agricole</li>
                            <li>Autobus, minibus</li>
                            <li>Taxi</li>
                            <li>Véhicule de livraison ou de service</li>
                            <li>Véhicule de ferme</li>
                            <li>Véhicule de chantier</li>
                        </ul>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>Bateaux ou autres embarcations nautiques</p>
                    </td>
                    <td>
                        <ul>
                            <li>
                                Bateau à moteur (moteur hors-bord ou intégré)
                            </li>
                            <li>Motomarine (type Sea-Doo)</li>
                            <li>Bateau de pêche</li>
                            <li>Voilier avec moteur auxiliaire</li>
                            <li>Yacht</li>
                        </ul>
                    </td>
                    <td>
                        <ul>
                            <li>Canot ou kayak avec moteur</li>
                            <li>Chaloupe motorisée</li>
                            <li>Bateau pneumatique à moteur</li>
                            <li>Traversier ou bateau commercial</li>
                        </ul>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>Aéronef</p>
                    </td>
                    <td>
                        <ul>
                            <li>Avion</li>
                            <li>Hélicoptère</li>
                            <li>Planeur</li>
                        </ul>
                    </td>
                    <td>
                        <ul>
                            <li>Aéronef ultraléger</li>
                            <li>Drone habité</li>
                            <li>Montgolfière</li>
                        </ul>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>Matériel ferroviaire</p>
                    </td>
                    <td>
                        <ul>
                            <li>Train (passagers ou marchandises)</li>
                            <li>Locomotive</li>
                            <li>Tramway</li>
                            <li>Métro</li>
                        </ul>
                    </td>
                    <td>
                        <ul>
                            <li>
                                Draisine ou véhicule d’entretien ferroviaire
                            </li>
                            <li>Train touristique</li>
                            <li>Monorail</li>
                        </ul>
                    </td>
                </tr>
            </table>
            <h4>
                <strong>Où l’infraction peut-elle être commise ?</strong>
            </h4>
            <p>
                L’infraction de conduite avec les facultés affaiblies n’est pas
                limitée à la voie publique. Même sur un terrain privé ou une
                voie qui n’est pas ouverte au public, il est interdit de
                conduire avec les facultés affaiblies.{' '}
            </p>
            <p>
                Peu importe le lieu où la personne conduit avec les facultés
                affaiblies, elle peut être arrêtée et accusée de cette
                infraction criminelle!
            </p>
            <h4>
                <strong>
                    Est-il légal de conduire un kart de golf sur un terrain de
                    golf avec les facultés affaiblies?
                </strong>
            </h4>
            <p>
                Non! Une personne qui conduit un kart de golf avec les facultés
                affaiblies peut être accusée de conduite avec les facultés
                affaiblies.
            </p>
            <p>
                <Img
                    fluid={data.img3.childImageSharp.fluid}
                    title="Conduire un bateau avec les facultés affaiblies est criminel!"
                    alt=""
                />
            </p>
            <p>
                Ce type de véhicule est considéré comme un « véhicule à moteur
                ». La loi s’applique, peu importe l’endroit où le moyen de
                transport est utilisé (voie publique ou terrain privé). Alors,
                conduire un kart motorisé sur le terrain de golf en état
                d’ébriété peut donc entraîner une condamnation criminelle!
            </p>
            <h2>
                <strong>
                    Est-ce que la présomption de conduite s’applique à tous les
                    moyens de transport?
                </strong>
            </h2>
            <p>
                Oui, la présomption de conduite s’applique à tous les moyens de
                transport visés par le Code criminel, et pas seulement aux
                voitures.
            </p>
            <h3>
                <strong>
                    Mais qu’entend-on exactement par « présomption de conduite »
                    ?
                </strong>
            </h3>
            <p>
                <Link to="https://avocatsalcoolauvolant.ca/accusation-controle-vehicule-alcool-volant/">
                    La présomption de conduite
                </Link>{' '}
                signifie qu’il n’est pas nécessaire d’avoir effectivement
                conduit ou déplacé un moyen de transport pour être reconnu
                coupable de conduite avec les facultés affaiblies par l’alcool.
            </p>
            <p>
                Même si vous n’avez pas mis le véhicule en mouvement, vous
                pouvez être tenu responsable si vous aviez{' '}
                <strong>la garde ou le contrôle de celui-ci</strong> au moment
                des faits.
            </p>
            <p>
                Lors d'une accusation de conduite avec les facultés affaiblies,
                le procureur de la Couronne doit prouver que l’accusé avait la
                garde ou le contrôle du moyen de transport, et pas
                nécessairement qu’il l’a conduit.{' '}
            </p>
            <p>
                Ainsi, être assis derrière le volant avec les clés en main
                constitue une preuve suffisante pour invoquer cette présomption.
            </p>
            <p>
                Cette règle empêche une personne en état d’ébriété d’avoir la
                possibilité de conduire un véhicule, même si elle n’a pas encore
                déplacé le véhicule. La loi part du principe que le simple
                contrôle ou la garde du véhicule dans cet état présente un
                danger, car l’individu pourrait mettre le véhicule en marche à
                tout moment.
            </p>
            <h4></h4>
            <h3>
                <strong>
                    Comment se défendre contre une accusation de conduite avec
                    facultés affaiblies?
                </strong>
            </h3>
            <p>
                Pour se défendre contre une accusation de conduite avec les
                facultés affaiblies d’un moyen de transport sans l’avoir
                réellement conduit, une personne peut soit démontrer qu’elle
                n’avait <strong>pas l’intention de le mettre en marche,</strong>{' '}
                soit prouver qu’elle n’en avait pas réellement la garde ou le
                contrôle.
            </p>
            <table>
                <tr>
                    <td>
                        <p>
                            <strong>Moyens de défense</strong>
                        </p>
                    </td>
                    <td>
                        <p>
                            <strong>Explication</strong>
                        </p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>Contester l’intention de conduire</p>
                    </td>
                    <td>
                        <p>
                            Une défense courante consiste à prouver que l’accusé{' '}
                            <strong>
                                n’avait pas l’intention réelle de conduire le
                                véhicule.
                            </strong>
                        </p>
                        <p>
                            Le tribunal analysera alors l’ensemble des
                            circonstances, y compris les témoignages et les
                            éléments de preuve, pour évaluer la crédibilité de
                            cette version.
                        </p>
                        <p>
                            L’accusé n’a pas à prouver son absence d’intention
                            hors de tout doute raisonnable, mais simplement à
                            démontrer qu’il est plus probable que non (selon la
                            prépondérance des probabilités) qu’il ne voulait pas
                            mettre le véhicule en marche.
                        </p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>Contester la garde ou le contrôle</p>
                    </td>
                    <td>
                        <p>
                            Une autre stratégie de défense consiste à contester
                            la garde ou le contrôle réel du véhicule.
                        </p>
                        <p>
                            Même si l’accusé est assis au volant, ces
                            circonstances peuvent suffire à écarter la
                            présomption de conduite prévue par la loi.
                        </p>
                    </td>
                </tr>
            </table>
            <p>
                Ces défenses sont applicables aux voitures, mais aussi à tous
                les moyens de transport visés par la loi. Contester l’intention
                de conduire ou la garde du véhicule peut ainsi permettre de
                renverser la présomption de conduite et d’éviter une
                condamnation.
            </p>
            <h2>
                <strong>
                    Vous êtes accusé pour conduite avec les facultés affaiblies
                    ? Consultez un avocat spécialisé en droit criminel !
                </strong>
            </h2>
            <p>
                Si vous êtes accusé de conduite avec les facultés affaiblies par
                l’alcool que ce soit au volant d’une voiture, d’un bateau, d’une
                motoneige ou tout autre moyen de transport, il est fortement
                recommandé de consulter un{' '}
                <Link to="https://avocatsalcoolauvolant.ca/avocat-criminel-alcool-volant/">
                    avocat spécialisé en droit criminel
                </Link>
                .
            </p>
            <p>
                <Img
                    fluid={data.img4.childImageSharp.fluid}
                    title="Avocat pour éviter une condamnation d’alcool au volant!"
                    alt=""
                />
            </p>
            <p>
                <strong>
                    Trouvez rapidement un avocat en droit criminel grâce à notre
                    formulaire simple et gratuit ! Une fois votre demande
                    soumise, nous vous mettons en relation avec un avocat près
                    de chez vous.
                </strong>
            </p>
            <p>
                <strong>
                    Ce service est entièrement gratuit et sans engagement, vous
                    offrant la liberté de faire un choix en toute tranquillité!
                </strong>
            </p>
        </SeoPage>
    )
}

export default ContentPage

export const pageQuery = graphql`
    query ($language: String!) {
        locales: allLocale(filter: { language: { eq: $language } }) {
            edges {
                node {
                    ns
                    data
                    language
                }
            }
        }
        img0: file(
            relativePath: {
                eq: "alcool-volant-vehicules/vehicules-alcool-volant-infraction-criminelle.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img1: file(
            relativePath: {
                eq: "alcool-volant-vehicules/interdiction-alcool-volant-moyens-transport.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img2: file(
            relativePath: {
                eq: "alcool-volant-vehicules/conduire-kart-golf-alcool-volant.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img3: file(
            relativePath: {
                eq: "alcool-volant-vehicules/conduire-bateau-facultes-affaiblies-criminel.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img4: file(
            relativePath: {
                eq: "alcool-volant-vehicules/avocat-alcool-volant-eviter-condamnation.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
    }
`
